import React, {createContext, useContext} from "react";
import {useLocation} from "react-router";

/**
 * The browser's location for pages routed for a background location (DE-1720, ADR-0008). Inside
 * <Routes location={background}>, useLocation() gives the background, so a page shown under a document can't see
 * the document's URL. BrowserLocationProvider, placed outside those routes, passes the real location in.
 */
const BrowserLocationContext = createContext(null);

export const BrowserLocationProvider = ({children}) =>
    <BrowserLocationContext.Provider value={useLocation()}>{children}</BrowserLocationContext.Provider>;

/**
 * @returns {Object} The browser's location; the router's own where no BrowserLocationProvider is above.
 */
export const useBrowserLocation = () => {
    const routed = useLocation();
    return useContext(BrowserLocationContext) ?? routed;
};
